/* global jQuery:false */


/*
 * training tabs
 */
(function ($) {

	"use strict";

	$(".js-q-training-tab").on("click", function(){

		//event.preventDefault();

		// get active tab target ID
		var tab = $(this).data("tab");

		// enable active tab
		$(".js-q-training-tab").removeClass("q-active-tab");
		$(this).addClass("q-active-tab");

		// show active tab content
		$(".q-training__tabs-content").addClass("q-tab-hidden");
		$(tab).removeClass("q-tab-hidden");

	});

	// get URL hash
	var hash = window.location.hash;

	// enable tabs by hash value
	if(hash && $("[data-tab='" + hash + "-tab']").length){
		$("[data-tab='" + hash + "-tab']").trigger("click");
	}


	$(".js-q-training-tab-instructor").on("click", function(){
		$(".js-q-training-tab").removeClass("q-active-tab");
		$("[href='#instructor-led']").addClass("q-active-tab");
		$(".q-training__tabs-content").addClass("q-tab-hidden");
		$("#instructor-led-tab").removeClass("q-tab-hidden");
		$.fancybox.close();
	});

}(jQuery));

/*
 * automatically open self-paced overlay based on hash value
 */
(function ($) {
	"use strict";

	$(document).ready(function () {
		// get hash value
		var hash = "";
		if (window.location.hash) {
			/* Puts hash in variable, and removes the # character */
			hash = window.location.hash.substring(1);
			/* remove initial slash if it exists */
			hash = hash.indexOf("/") == 0 ? hash.substring(1) : hash;
		}

		// trigger the click on hash selectors

		$("[href='#course_"+ hash +"']").trigger( "click" );

	});
}(jQuery));

/*
 * instructor training dropdown
 */
(function ($) {
    "use strict";

    $(document).ready(function () {
        // var allCourses = true;
        // var allMonths = true;
        // var allTimezones = true;

        // Handle filter change for Course
        $(".js-classes-filter").on("change", function () {
            var selectedCourse = $(this).find(":selected").val();
            filterClasses(selectedCourse, $(".js-month-filter").val(), $(".js-tz-filter").val());
        });

        // Handle filter change for Month
        $(".js-month-filter").on("change", function () {
            var selectedMonth = $(this).find(":selected").val();
            filterClasses($(".js-classes-filter").val(), selectedMonth, $(".js-tz-filter").val());
        });

        // Handle filter change for Timezone
        $(".js-tz-filter").on("change", function () {
            var selectedTZ = $(this).find(":selected").val();
            filterClasses($(".js-classes-filter").val(), $(".js-month-filter").val(), selectedTZ);
        });

        // Function to filter classes based on selected filters
        function filterClasses(selectedCourse, selectedMonth, selectedTZ) {
            // Hide all rows initially
            $(".js-course-row").hide();

            // Iterate through each course row to apply filters
            $(".js-course-row").each(function () {
                var courseTitle = $(this).data("title");
                var courseDate = new Date($(this).data("date"));
                var courseTZ = $(this).data("tz");
				var courseMonthYear = courseDate.toLocaleString("en-US", { month: 'long', year: 'numeric'});

                var matchesCourse = selectedCourse === "all" || courseTitle === selectedCourse;
                var matchesMonth = selectedMonth === "all" || courseMonthYear === selectedMonth;
                var matchesTZ = selectedTZ === "all" || courseTZ === selectedTZ;

                // Show rows that match all filter criteria
                if (matchesCourse && matchesMonth && matchesTZ) {
                    $(this).show();
                }
            });

            // If no filters are applied, show all rows
            if (selectedCourse === "all" && selectedMonth === "all" && selectedTZ === "all") {
                $(".js-course-row").show();
            }
        }

        // Expand or collapse the row on click (excluding "Sign Up" link)
        $(document).on("click", ".js-course-row", function (event) {
            if (!$(event.target).closest('.q-course-action').length) {
                $(this).toggleClass("expand");
            }
        });
    });

}(jQuery));

